module.exports = __webpack_public_path__ + "static/media/logo.aa70eaab.svg";